module.exports = __webpack_public_path__ + "img/spin_btn.7de5241f.png";